import "./Hero04.css";

function Hero04() {
  return (
    <div className="Hero04 section" id="Hero04">
      <div className="container">
        <div className="intro">
          <p className="eyebrow">LOCATIONS </p>
          <h2>We're Now in 3 Locations.</h2>
          <p>
            Book your appointment for a modern cut, classic shave, or the VIP
            experience.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hero04;
